import React from "react";

const DataTable = ({ headCells, children, colSpan = 1 }) => {
  return (
    <table className="datatable text-base mb-8 shadow-grey shadow-[0_5px_20px_0]">
      <thead>
        <tr className="bg-brown text-white *:font-medium">
          {headCells.map((ele, ind) => (
            <th key={ind} colSpan={colSpan}>
              {ele}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  );
};

export default DataTable;
